import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { history } from 'src/core/router'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang:langM.en,
    language:'en',
    adminsList: [],
    hostSystemInfo: {},
    hostList:[],
    scroll:'0:20',
    hasMore:false,
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    if (language == 'en') {
      setDocumentTitle('Manage Host')
    }else if (language == 'ar') {
      setDocumentTitle(" إدارة المضيف")
    }else if (language == 'tr') {
      setDocumentTitle("Ajansı Yönet")
    }
    // end
    let uid = await setUidToken(this.props.location.query)
    this.getHostsystem()
    this.getAdminList()
    this.getHostList()
  }
  //跳转操作页
  hanldeTogo = (item) => {
    
    localstorage.set('updataInfo',{hostSystemId:this.state.hostSystemInfo.hostSystemId,uid:item.uid,roleLevel:this.state.hostSystemInfo.roleLevel})
    history.push(`app/host-Info?language=${this.state.language}`)
  }
  hanldeAdminTogo = (item) => {
    if (this.state.hostSystemInfo.roleLevel != 1) return
    localstorage.set('updataInfo',{hostSystemId:this.state.hostSystemInfo.hostSystemId,uid:item.uid,roleLevel:this.state.hostSystemInfo.roleLevel})
    history.push(`app/host-Info?language=${this.state.language}`)
  }
  //会长跳转
  hanldeBossTogo= (item) => {
    if (this.state.hostSystemInfo.roleLevel != 1) return
    localstorage.set('updataInfo',{hostSystemId:this.state.hostSystemInfo.hostSystemId,uid:this.state.hostSystemInfo.ownerUid,roleLevel:4})
    history.push(`app/host-Info?language=${this.state.language}`)
  }
  goAddHost = () => {
    let {hostSystemInfo} = this.state
    history.push(`app/invite-new-host?language=${this.state.language}`)
    localstorage.set('hostSystem',{uid:hostSystemInfo.ownerDuid,hostSystemId:hostSystemInfo.hostSystemId})
  }
  getHostsystem = async () => {
    let res = await http.post('/web/hostsystem/info')
    //判断状态
    if (res.code == 0 && res.res != null) {
      this.setState({ hostSystemInfo: res.res })
      console.log(this.state)
    }
  }
  getAdminList= async()=>{
    let res = await http.post('/web/hostsystem/user/adminlist')
    console.log(res)
    if (res.code == 0 && res.res) {
      this.setState({adminsList:res.res})
    }
  }
  getHostList = async()=>{
    let res = await http.post('/web/hostsystem/user/hostlist' ,{scroll:"0:20"})
    if (res.code ==0 && res.res.list) {
      this.setState({
        hostList:res.res.list,
        scroll: res.res.scroll,
        hasMore: res.res.hasMore,
      })
    }
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore } = this.state
    if ((scrollTop + clientHeight + 50) >= scrollHeight) {
      if (hasMore) return this.addRankingList()
    }
  }
   

  addRankingList = async () => {
    let { scroll, hostList } = this.state
    let res = await http.post('/web/hostsystem/user/hostlist', { scroll })
    if (res.code == 0) {
      this.setState({
        hostList: res.res.list.length && [...hostList, ...res.res.list],
        scroll: res.res.scroll,
        hasMore: res.res.hasMore,
      })
    }
  }
  showListAndTitle = (titie,hostList) => {
    return (
     (hostList.length>0 && <div className='leader-admins' onScroll={(e) => this.handleScroll(e)} >
      
      {hostList.length>0 && hostList.map((item,index)=>(<div className='addminList' key={index}>
        <div className="addminList-user-info"  onClick={()=>this.hanldeTogo(item)}>
          <div className="avatar-root">
            <img className="avatar-img" src={item.avatarurl}></img>
            {item.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                {item.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
          </div>
          <div className="user-info">
            <div className="user-info-top">
              <div className="top-text">{item.nickname}</div>
              <div className='host-bg'>{this.state.lang.host}</div>
            </div>
            <div className="user-info-buttom">ID:{item.duid}</div>
          </div>
          <div className="host-get-ruby"  style={{marginRight:`${titie == 'ar'?'auto':''}`,marginLeft:`${titie == 'ar'?'':'auto'}`}}>
            {/* <div className="ruby-num">{item.target}</div> */}
            <img className="ruby-forWard" src="/img/app/tradeUnion/icon_chevron_forward.png"  ></img>
          </div>
        </div>
      </div>))}
    </div>)
    )
  }
  applyReview=()=>{
   /*  if (this.state.hostSystemInfo.roleLevel != 1) return */
    localstorage.set('updataInfo',{hostSystemId:this.state.hostSystemInfo.hostSystemId,uid:this.state.hostSystemInfo.ownerUid,roleLevel:4})
    history.push(`app/join-application?language=${this.state.language}`)
  }
  render() {
    let { lang, adminsList, hostSystemInfo, hostList, language } = this.state
    return (
      <div className={`management-host ${isRtl(language)?'in-tr':''}` }>

        <div className='add-host' onClick={this.applyReview} style={{marginTop:'0.24rem'}}>
          <img className='add-host-icon' src='/img/app/managementGo/icon_file_check.png'></img>
          <div className='add-host-title'>{lang.joinApplication}</div>
          <img className='to-add-host' src='/img/app/tradeUnion/icon_chevron_forward.png' style={{marginRight:`${isRtl(language)?'auto':''}`,marginLeft:`${isRtl(language)?'none':'auto'}`}} ></img>
        </div>
        <div className='host-list'>
          <div className='title'>
            <div className='title-left'>{lang.hostList}</div>
            {/* <div className='title-right'></div> */}
          </div>
          <div className="info-title-after"></div>
          <div className='leader-admins'>
            <div className='leader-admins-title'>{lang.leaderAdmins}</div>
            {/* Leader */}
            <div className="application-user-info">
              <div className="avatar-root">
                <img className="avatar-img" src={hostSystemInfo.ownerAvatarurl}></img>
                {hostSystemInfo.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                {hostSystemInfo.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
              </div>
              <div className="user-info" >
                <div className="user-info-top" onClick={this.hanldeBossTogo}>
                  <div className="top-text">{hostSystemInfo.ownerNickname}</div>
                  <div className="vip-bg">{lang.leader}</div>
                </div>
                <div className="user-info-buttom">ID:{hostSystemInfo.ownerDuid}</div>
              </div>
              <div className="host-get-ruby"  onClick={this.hanldeBossTogo}   style={{marginRight:`${isRtl(language)?'auto':''}`,marginLeft:`${isRtl(language)?'':'auto'}`}} >
                 
                  {hostSystemInfo && hostSystemInfo.roleLevel == 1 && <img className="ruby-forWard" src="/img/app/tradeUnion/icon_chevron_forward.png" ></img>}
                </div>
            </div>
            {adminsList.length>0 && adminsList.map((item,index)=>{
              return(<div className='addminList' key={index}>
              <div className="application-user-info" onClick={()=>this.hanldeAdminTogo(item)}>
                <div className="avatar-root">
                  <img className="avatar-img" src={item.avatarurl}></img>
                  {item.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                {item.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{item.nickname}</div>
                    <div className="admin-bg">{lang.admin}</div>
                  </div>
                  <div className="user-info-buttom">ID:{item.duid}</div>
                </div>
                <div className="host-get-ruby"   style={{marginRight:`${isRtl(language)?'auto':''}`,marginLeft:`${isRtl(language)?'':'auto'}`}} >
                 {/*  <div className="ruby-num">{item.target}</div> */}
                  {hostSystemInfo && hostSystemInfo.roleLevel == 1 && <img className="ruby-forWard" src="/img/app/tradeUnion/icon_chevron_forward.png"  ></img>}
                </div>
              </div>
            </div>)
            })}
          </div>
          <div className='leader-admins-title'>{this.state.lang.hosts}</div>
          {true && this.showListAndTitle(language, hostList)}
        </div>
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/managementGo/index.js